export default "__VITE_ASSET__9bc45926__"